
import CloseIcon from '@mui/icons-material/Close';
import {
    Button,
    Dialog, DialogContent, DialogTitle,
    Grid,
    IconButton,
    Tooltip,
    Typography
} from '@mui/material';

import SyntaxHighlighter from 'react-syntax-highlighter';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Formik } from 'formik';
import { useContext, useState } from 'react';
import { DataContext } from '../../../../contexts';
import { ResearchContext } from '../../ResearchContext';

export const LinkCreationDialog = ({ isOpen, handleClose }) => {

    const [showLinkSection, setShowLinkSection] = useState(false);
    const [tooltipMessage, setTooltipMessage] = useState("Copia");
    const [link, setLink] = useState("");
    const [relativeLink, setRelativeLink] = useState("");

    const {
        comuneFilter,
        regioneFilter,
        provinciaFilter,
        distrettoFilter,
        circondarioFilter,
        tipoUfficioFilter,
        testoFilter,
    } = useContext(ResearchContext)

    const {
        impostazioni
    } = useContext(DataContext);


    const handleOnSubmit = async (values) => {
        var baseUrl = window.location.origin;
        var script = `?comune=${comuneFilter}&distretto=${distrettoFilter}&circondario=${circondarioFilter}&provincia=${provinciaFilter}&regione=${regioneFilter}&tipoUfficio=${tipoUfficioFilter}&testo=${testoFilter}`.replace(/ /g, '%20');
        setLink(`${baseUrl}${script}`);
        setRelativeLink(`${script}`);
        setShowLinkSection(true);
    }

    const handleOnClose = () => {
        setLink("");
        setRelativeLink("");
        setShowLinkSection(false);
        handleClose();
    }

    return (
        <Dialog open={isOpen} maxWidth='sm' fullWidth>
            <IconButton
                aria-label="close"
                size="small"
                sx={{
                    position: "absolute",
                    top: 8,
                    right: 4,
                }}
                onClick={handleOnClose}>
                <CloseIcon />
            </IconButton>
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
                CREAZIONE LINK
            </DialogTitle>
            <DialogContent>
                <Formik
                    enableReinitialize
                    initialValues={
                        {
                            height: 600,
                            width: 600,
                            includeResultTable: true
                        }
                    }
                    onSubmit={handleOnSubmit}>
                    {({
                        handleSubmit,

                    }) => {
                        return <form onSubmit={handleSubmit}>
                            <Grid container justifyContent={'center'} sx={{ marginTop: '8px' }}>
                                <Grid item sx={{ width: '100%' }} >
                                    <Button
                                        type='submit'

                                        variant='contained' disableElevation fullWidth sx={{ height: '57px', width: '100%' }}>
                                        <Typography>
                                            Genera link
                                        </Typography>
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    }}
                </Formik>
                {
                    showLinkSection ?
                        <>
                            <div
                                style={{
                                    position: 'relative',
                                }}>
                                <SyntaxHighlighter language="html" id='linkRisultatoRicerca'>
                                    {link}
                                </SyntaxHighlighter>
                                <Tooltip title={tooltipMessage} onClose={() => {
                                    setTooltipMessage("Copia");
                                }}>
                                    <IconButton sx={{
                                        position: 'absolute',
                                        top: '4px',
                                        right: '4px'
                                    }}

                                        onClick={() => {
                                            navigator.clipboard.writeText(link);
                                            setTooltipMessage("Copiato nella clipboard!");

                                        }}>
                                        <ContentCopyIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                            <div
                                style={{
                                    position: 'relative',
                                }}>
                                <SyntaxHighlighter language="html" id='linkRisultatoRicercaRelative'>
                                    {relativeLink}
                                </SyntaxHighlighter>
                                <Tooltip title={tooltipMessage} onClose={() => {
                                    setTooltipMessage("Copia");
                                }}>
                                    <IconButton sx={{
                                        position: 'absolute',
                                        top: '4px',
                                        right: '4px'
                                    }}

                                        onClick={() => {
                                            navigator.clipboard.writeText(link);
                                            setTooltipMessage("Copiato nella clipboard!");

                                        }}>
                                        <ContentCopyIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </>
                        :
                        <></>
                }
            </DialogContent>
        </Dialog>
    )
}